import React, { Component } from "react";

export class AddTodoForm extends Component {
	componentDidMount = () => {
		this.props.inputRef.current.focus();
	};

	inputValueChangeHandler = (e) => {
		this.props.updateText(e);
	};

	submitHandler = (e) => {
		e.preventDefault();
		this.props.addTodoSubmission();
	};

	todoDetailsAdditionHandler = (e) => {
		this.props.updateDetails(this.props.todos[this.props.todos.length - 1].id, e.target.value);
	};

	render() {
		const { todoText } = this.props;
		const wannaAddDetails = this.props.wannaDetails;
		const todoDetails = this.props.todoDetails;
		return (
			<>
				<form className="add-todo-form" onSubmit={this.submitHandler}>
					<input
						ref={this.props.inputRef}
						value={todoText}
						onChange={this.inputValueChangeHandler}
					/>
					<button type="submit">Add Todo</button>
				</form>
				{wannaAddDetails ? (
					<form className="add-details-form">
						<input value={todoDetails} onChange={this.todoDetailsAdditionHandler} />
					</form>
				) : null}
			</>
		);
	}
}

export default AddTodoForm;
